const GuideResourceTypes = [
    {
        id: 'UnderwritingGuideline',
        title: 'UW Guide',
    },
    {
        id: 'ProgramGuide',
        title: 'Program Guides',
    },
    {
        id: 'RateBulletin',
        title: 'Rate Bulletin',
    },
    // {
    //     id: 'EligibilityGuide',
    //     title: 'Eligibility Guide',
    // },
];

const findGuideResourceTypeById = (id) => {
    return GuideResourceTypes.find((resourceType) => resourceType.id === id);
};

export {
    GuideResourceTypes,
    findGuideResourceTypeById,
};
